import React from "react";

const LoggedOutUserIcon = () => (
  // <svg
  //   className="h–32 w-32 flex justify-center items-center"
  //   data-testid="logged-out-user-icon"
  //   width="17"
  //   height="19"
  //   viewBox="0 0 17 19"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     d="M10.5701 5.88874L10.5696 5.88921C10.0015 6.45792 9.23097 6.77701 8.42687 6.77701C7.62278 6.77701 6.85223 6.45792 6.28411 5.88921L6.28363 5.88874C5.71493 5.32062 5.39584 4.55007 5.39584 3.74597C5.39584 2.94188 5.71493 2.17132 6.28363 1.60321L6.28411 1.60273C6.85223 1.03403 7.62278 0.714941 8.42687 0.714941C9.23097 0.714941 10.0015 1.03403 10.5696 1.60273L10.5701 1.60321C11.1388 2.17132 11.4579 2.94188 11.4579 3.74597C11.4579 4.55 11.1388 5.32063 10.5701 5.88874ZM0.797961 17.3107L0.797988 17.3105C1.14217 14.8343 2.66672 12.6795 4.88644 11.5298C7.1068 10.3808 9.74691 10.3808 11.9673 11.5298C14.1871 12.6797 15.7118 14.8344 16.0559 17.3104L16.0559 17.3106C16.0702 17.4132 16.0394 17.517 15.9712 17.5954C15.9031 17.6738 15.8048 17.7187 15.7015 17.7191C15.7013 17.7191 15.7011 17.7191 15.7009 17.7191H1.15295C1.15276 17.7191 1.15256 17.7191 1.15237 17.7191C1.04912 17.7187 0.950813 17.6738 0.882724 17.5955C0.81445 17.5169 0.783686 17.4131 0.797961 17.3107Z"
  //     stroke="black"
  //     strokeWidth="1.3"
  //   />
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h–32 w-32 flex justify-center items-center"
    data-testid="logged-out-user-icon">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

export default LoggedOutUserIcon;
